/** @todo FC-739 Удалить из package.json */
import { deviceInfo } from '@ott/device-info-context';

import { LAYOUTS } from './constants';
import { determineLayout } from './determineLayout';

const {
  isMobile: isMobileDevice,
  isTablet: isTabletDevice,
  isDesktop: isDesktopDevice,
} = deviceInfo;

/** @deprecated */
export type LayoutContextValue = {
  isMobileDevice: boolean;
  isTabletDevice: boolean;
  isDesktopDevice: boolean;

  isMobileLayout: boolean;
  isTabletLayout: boolean;
  isDesktopLayout: boolean;
  isDesktopWideLayout: boolean;
};

/** @deprecated */
export const getLayoutContextValue = (size: number): LayoutContextValue => {
  const layout = determineLayout(size);

  const isMobileLayout = layout === LAYOUTS.MOBILE;
  const isTabletLayout = layout === LAYOUTS.TABLET;
  const isDesktopLayout = !isMobileLayout && !isTabletLayout;
  const isDesktopWideLayout = layout === LAYOUTS.DESKTOP_WIDE;

  return {
    isMobileDevice,
    isTabletDevice,
    isDesktopDevice,

    isMobileLayout,
    isTabletLayout,
    isDesktopLayout,
    isDesktopWideLayout,
  };
};
